import {
    DIVISION_FETCHING,
    DIVISION_FAILED,
    DIVISION_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case DIVISION_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case DIVISION_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case DIVISION_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  